<template>
  <b-overlay :show="loading" rounded="sm" spinner-variant="primary" opacity="0.25">
    <p class="my-3">선택하신 항목을 PDF 문서로 다운로드 합니다.</p>
    <div v-for="(lv1_info, lv1_idx) in sb_toc" :key="lv1_idx">
      <b-form-checkbox v-model="selected" class="mb-3" :value="lv1_info">
        {{ lv1_info.name }}
      </b-form-checkbox>
    </div>

    <b-form-invalid-feedback :state="state">목차를 하나 이상 선택해주세요!</b-form-invalid-feedback>
    <div class="text-left mt-4">
      <b-button
        v-b-tooltip.hover
        :disabled="!state"
        variant="teal"
        :title="lang != 'ENG' ? '출력하기' : 'Print to PDF'"
        @click="handleDownload"
      >
        PDF 다운로드
      </b-button>
      <b-button variant="secondary" class="ml-2" @click="closePrintOption"> 취소 </b-button>
    </div>
  </b-overlay>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import PrintSb from '@/plugins/print_plugin/printareaSb.js';

export default {
  name: 'SbPrintOption',
  computed: {
    ...mapState('report_list', ['lang']),
    ...mapGetters('report_list', ['selected_report']),
    ...mapGetters('story_board', ['sb_toc']),
    ...mapState('story_board', [
      'selectedLv1PrintOption',
      'viewer_sb_toc',
      'editor_sb_toc',
      'viewer_disclosure_map',
      'print_mode'
    ]),

    state() {
      return this.selected.length > 0;
    },
    popTitle() {
      const baseTitle =
        this.lang === 'KOR' ? this.selected_report.report_name : this.selected_report.report_name_e;

      if (this.selected && this.selected.length === 1) {
        return `${baseTitle}_${this.selected[0].name}`;
      }
      return baseTitle;
    }
  },
  data() {
    return {
      selected: [],
      loading: false,
      closeBtn: true
    };
  },

  watch: {
    sb_toc: {
      immediate: true,
      handler() {
        this.selected = JSON.parse(JSON.stringify(this.sb_toc));
      }
    }
  },
  methods: {
    ...mapMutations('story_board', ['update_print_option']),
    closePrintOption() {
      this.loading = false;
      this.$store.commit('story_board/update_print_mode', false);
      this.$bvModal.hide('story-board-modal');
    },

    async handleDownload() {
      this.loading = true;
      this.update_print_option(this.selected);

      // DOM 업데이트 및 리소스 로딩 대기
      await this.$nextTick();
      await this.waitForResources();

      if (!this.loading) return;

      if (this.closeBtn) {
        this.closeBtn = false;
        new PrintSb({
          ids: '#full-report-preview-sb',
          popTitle: this.popTitle,
          selectedLv1PrintOption: this.selected,
          endCallback: () => {
            this.closeBtn = true;
            this.loading = false;
          }
        });
      }
    },

    waitForResources() {
      return new Promise(resolve => {
        const checkInterval = 500;
        const maxWaitTime = 30000; // 최대 30초
        let elapsedTime = 0;

        const intervalId = setInterval(() => {
          if (!this.loading) {
            clearInterval(intervalId);
            resolve();
            return;
          }

          const printElement = document.querySelector('#full-report-preview-sb');

          // 요소가 아직 없으면 대기
          if (!printElement) {
            if (elapsedTime >= maxWaitTime) {
              clearInterval(intervalId);
              resolve();
            }
            elapsedTime += checkInterval;
            return;
          }

          // 이미지 로딩 확인
          const images = Array.from(printElement.querySelectorAll('img'));
          const allImagesLoaded = images.every(img => img.complete);

          if (allImagesLoaded || elapsedTime >= maxWaitTime) {
            clearInterval(intervalId);
            // 렌더링 안정화를 위해 1초 추가 대기
            setTimeout(resolve, 1000);
          }

          elapsedTime += checkInterval;
        }, checkInterval);
      });
    }
  }
};
</script>

<style>
/* 모달이 열렸을 때 백그라운드 스크롤 방지 (전역 스타일) */
body.modal-open {
  overflow: hidden !important;
  position: fixed !important;
  width: 100% !important;
}
</style>
